import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, message } = formData;

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      setStatus({
        type: "error",
        message:
          "Email service is not configured. Please add your EmailJS IDs to the environment variables.",
      });
      return;
    }

    setIsSending(true);
    setStatus({ type: "", message: "" });

    try {
      const formattedMessage = `${message}\n\nReply To: ${email}`;

      await emailjs.send(
        serviceId,
        templateId,
        {
          name,
          email,
          message: formattedMessage,
          title: "New Portfolio Message",
          time: new Date().toLocaleString(),
        },
        publicKey
      );

      setStatus({
        type: "success",
        message:
          "Message sent successfully! I'll reply from ghalifaycal27@gmail.com soon.",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      setStatus({
        type: "error",
        message:
          "Failed to send the message. Please try again later or reach out via ghalifaycal27@gmail.com.",
      });
      console.error("EmailJS error", error);
    } finally {
      setIsSending(false);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section id="contact" className="contact section" ref={ref}>
      <motion.div
        className="contact-container terminal-window"
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        <div className="terminal-header">
          <div className="terminal-buttons">
            <span className="terminal-button red"></span>
            <span className="terminal-button yellow"></span>
            <span className="terminal-button green"></span>
          </div>
          <div className="terminal-title">/contact/new-message</div>
        </div>
        <div className="section-header">
          <h2>Contact Me</h2>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <motion.div className="form-group" variants={itemVariants}>
            <input
              type="text"
              id="name"
              name="name"
              className="form-input"
              placeholder=" "
              value={formData.name}
              onChange={handleChange}
              required
            />
            <label htmlFor="name" className="form-label">
              Name
            </label>
          </motion.div>
          <motion.div className="form-group" variants={itemVariants}>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              placeholder=" "
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label htmlFor="email" className="form-label">
              Email
            </label>
          </motion.div>
          <motion.div className="form-group" variants={itemVariants}>
            <textarea
              id="message"
              name="message"
              className="form-input"
              placeholder=" "
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <label htmlFor="message" className="form-label">
              Message
            </label>
          </motion.div>
          <motion.button
            type="submit"
            className="submit-btn"
            variants={itemVariants}
            disabled={isSending}
          >
            {isSending ? "Sending..." : "Send Message"}
          </motion.button>
          {status.message && (
            <motion.p
              className={`form-status ${status.type}`}
              variants={itemVariants}
              aria-live="polite"
            >
              {status.message}
            </motion.p>
          )}
        </form>
      </motion.div>
    </section>
  );
};

export default Contact;
